import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { asignarAsesoria } from '../../actions/asesorias';

const TomarAsesoria = ({ asesoria, reestablecerAsesoria }) => {

    const dispatch =  useDispatch();

    const { usuario } = useSelector(state => state.auth);

    const [tomarModal, setTomarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Tomar asesoria */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(asignarAsesoria({ id: asesoria?._id, asesor: usuario?._id }));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerAsesoria(null);
            setTomarModal(false);
        }
    }

    useEffect(() => {
        if(asesoria != null){
            setTomarModal(true);
        }
    }, [asesoria]);

    return (
        <Modal show={tomarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Tomar asesoría</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas tomar la asesoría de <strong>{asesoria?.cliente || 'este cliente'}</strong>?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sí</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Sí</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default TomarAsesoria;
